import { Typography, Listy } from 'antd';
import classes from './errorPopoverContent.module.scss';
import { TFunction } from 'i18next';

export const getErrorPopoverContent = (t: TFunction) => {
  const recommendations = [
    t('uploadProgressPanel.error.checkInternet'),
    t('uploadProgressPanel.error.tryAgain'),
    t('uploadProgressPanel.error.contactSupport'),
  ];

  return (
    <div className={classes.errorPopover}>
      <Typography.Title level={4}>{t('uploadProgressPanel.error.title')}</Typography.Title>
      <Typography.Title level={5}>{t('uploadProgressPanel.error.recommendations')}</Typography.Title>
      <Listy
        items={recommendations}
        rowKey={(item) => item}
        itemRender={(item) => (
          <div className={classes.errorListItem}>
            {item}
          </div>
        )}
      />
    </div>
  );
};

